import React from "react";
import PropTypes from "prop-types";
import ActiveFilter from "components/molecules/ActiveFilter";
import { LEHRERINNEN_TOGGLE } from "constants/filter";
import { debugModeArgument } from "utils/debugModeArgument";

const removeFilterValue = (currentValues, valueToRemove) => {
  return currentValues.filter((value) => value.value !== valueToRemove);
};

const ActiveFilterPanel = ({
  filters = [],
  onFilterChange,
  onFilterReset,
  resetAllCaption = "Alle Filter zurücksetzen",
  title = "Gewählte Filter",
}) => {
  const componentBaseClass = "sal-active-filter-panel";

  const onFilterDelete = (name, value) => {
    const changedFilter = filters.find((filter) => filter.name === name);
    const newFilterValues = removeFilterValue(changedFilter.values, value);

    onFilterChange(
      name,
      newFilterValues.map((value) => value.value),
    );
  };

  const onFilterDeleteAll = (ev) => {
    ev.preventDefault();
    onFilterReset();
  };

  const buildActiveFilterElements = (name, filterType, values) => {
    return (
      values &&
      values.map((filterValue, index) => {
        return (
          <span
            className={`${componentBaseClass}__filter-item`}
            key={name + "-" + index}
          >
            <ActiveFilter
              name={name}
              type={filterType}
              value={filterValue && filterValue.value}
              label={filterValue && filterValue.label}
              onResetFilter={onFilterDelete}
            />
          </span>
        );
      })
    );
  };

  // special toggle value should not be shown in ActiveFilter
  filters = filters.filter(
    (filter) => filter.name != LEHRERINNEN_TOGGLE.FILTER_INPUT_NAME,
  );

  const activeFilters = filters.map((filter) =>
    buildActiveFilterElements(filter.name, filter.filterType, filter.values),
  );

  return activeFilters.length ? (
    <section
      className={componentBaseClass}
      data-cv-debug={debugModeArgument("true")}
      data-cv-debug-system={debugModeArgument("SAL")}
      data-cv-debug-component={debugModeArgument("ActiveFilterPanel")}
    >
      {title && <h1 className={`${componentBaseClass}__title`}>{title}</h1>}
      <div className={`${componentBaseClass}__filter-container`}>
        {activeFilters}
        <div
          className={`${componentBaseClass}__reset-all`}
          onClick={onFilterDeleteAll}
        >
          <button className={`${componentBaseClass}__reset-all-button`}>
            <span
              className={`${componentBaseClass}__reset-all-icon cvds-icon cvds-icon--Reset cvds-icon--size-s cvds-icon--style-outline`}
              aria-hidden="true"
            />
            <span className={`${componentBaseClass}__reset-all-caption`}>
              {resetAllCaption}
            </span>
          </button>
        </div>
      </div>
    </section>
  ) : null;
};

ActiveFilterPanel.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      filterType: PropTypes.string,
      values: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string,
          label: PropTypes.string,
          count: PropTypes.number,
        }),
      ),
    }),
  ),
  onFilterChange: PropTypes.func.isRequired,
  onFilterReset: PropTypes.func.isRequired,
  resetAllCaption: PropTypes.string,
  title: PropTypes.string,
};

export default ActiveFilterPanel;
